import {$} from "../constants";

export default function SetupAlerts() {
    $('.alert').find('.close').on('click', function() {
        const $alert = $(this).parents('.alert');
        $alert.remove();
    })
}
